import { render, staticRenderFns } from "./serviceManagement.vue?vue&type=template&id=540caea0"
import script from "./serviceManagement.vue?vue&type=script&lang=js"
export * from "./serviceManagement.vue?vue&type=script&lang=js"
import style0 from "./serviceManagement.vue?vue&type=style&index=0&id=540caea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports